export default __webpack_public_path__ + "static/media/5.eb22cd0e.webp";